/**
 * @generated SignedSource<<ebb6aca919bfaece8acade65a521762c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReferralPartnerSourceForm_referralPartnerSource$data = {
  readonly description: string;
  readonly isActive: boolean;
  readonly name: string;
  readonly " $fragmentType": "ReferralPartnerSourceForm_referralPartnerSource";
};
export type ReferralPartnerSourceForm_referralPartnerSource$key = {
  readonly " $data"?: ReferralPartnerSourceForm_referralPartnerSource$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReferralPartnerSourceForm_referralPartnerSource">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReferralPartnerSourceForm_referralPartnerSource",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isActive",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "ReferralPartnerSource",
  "abstractKey": null
};

(node as any).hash = "a70057486ee9f148dc631d3c0826245f";

export default node;
